<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-5 pb-4">
          <u class="ft12Black">CARTA DE INSTRUCCIÓN DE PAGO A LA ASEGURADORA</u>
        </div>
        <div class="col-12 text-right">
          <span class="ft11">
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }},
            </span>
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.estado_cliente }},
            </span>
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.
              </span>
          </span>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft10">
            Apoderado o Representante Legal de <br />
            GPI AUTO COMERCIAL SAPI DE C.V. <br />
            <br />
            Con referencia al contrato de apertura de crédito simple con
            garantía prendaria sin transmisión de la posesión, celebrado el día
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}</span
            >
            (en adelante el " Contrato"), entre el suscrito y su representada,
            me permito:
            <br />
            Autorizar e instruir para que, en mi nombre y representación,
            entreguen la cantidad de
            <span v-bind:class="{ marca: data.showMarca }">
              ${{ data.precio_seguro }}</span
            >, el cual corresponde al importe de la prima del Seguro, a la
            institución de seguros
            <span v-bind:class="{ marca: data.showMarca }">
              {{data.seguro_nombre}}.
            </span> en su carácter de Aseguradora, mediante cheque o transferencia
            bancaria a la cuenta que determine éste último, de conformidad con
            el inciso H de la Cláusula Octava del Contrato. El Acreditado y el
            Acreditante convienen en que éste último, de acuerdo con lo
            establecido en el Contrato recibe en prenda sin transmisión de la
            posesión el Bien, referido en la factura
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_factura }}
            </span>
            DEL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_factura }},
            </span> expedida por
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.emisor_factura }},
            </span>
            incluyendo las siguientes características e información:
            <br />
            <br />
            Descripción de Vehículo:<br />
            Marca:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.marca_vehiculo }}</span
            ><br />
            Año:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.año_vehiculo }}</span
            ><br />
            Modelo:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.modelo_vehiculo }}</span
            ><br />
            Número de Motor:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_motor_vehiculo }}</span
            ><br />
            Número de Serie:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_serie_vehiculo }}</span
            ><br />
            Información adicional: <br />
            Cabe señalar que los términos que se encuentren definidos en
            cualquier parte del Contrato, serán aplicables a la presente en lo
            conducente.
          </span>
        </div>
        <div class="col-12 row p-5">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-dark text-center">
            <span class="ft11">
              ATENTAMENTE
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>

        <div v-if="data.tipoClasico" class="col-12 row">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span v-bind:class="{ marca: data.showMarca }" class="ft11 ">
              {{ data.nombre_cliente }}
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoClasico" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pb-5">
            <span class="ft11">
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoAval" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft10Black">
                {{ data.nombre_aval }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft10Black">
                {{ data.nombre_obligado }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligadoAval" class="col-12 row pt-4">
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ marca: data.showMarca }" class="ft9Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft9Black">
                {{ data.nombre_aval }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft9Black">
                {{ data.nombre_obligado }}</span
              ><br />
              NOMBRE Y FIRMA DEL“AVAL Y OBLIGADO SOLIDARIO"

            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/IntruccionPagoAseguradora.vue